var map = {
	"./ComicSansMS-Bold.ttf": 1815,
	"./ComicSansMS-Regular.ttf": 1816,
	"./OpenDyslexic-Bold.ttf": 1817,
	"./OpenDyslexic-Regular.ttf": 1818,
	"./Roboto-Bold.ttf": 1819,
	"./Roboto-Regular.ttf": 1820
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1814;